import './url';
import {
  useLocation,
  useNavigate,
  useParams
} from "react-router-dom";

function isClassComponent(component) {
  return typeof component === 'function' && !!component.prototype.isReactComponent ? true : false;
}

export function isReactComponent(component) {
  return isClassComponent(component) ? true : false;
}

// export function isElement(element) {
//   return React.isValidElement(element);
// }

// export function isDOMTypeElement(element) {
//   return isElement(element) && typeof element.type === 'string';
// }

// export function isCompositeTypeElement(element) {
//   return isElement(element) && typeof element.type === 'function';
// }

export function generateLoadingDataURL(width = 360, height = 202, iconScale = 2, iconColor = '#FFFFFF', backgroundColor = '#F2F4F8') {
  width = +width;
  height = +height;
  iconScale = +iconScale;
  if (!iconScale) {
    iconScale = 1;
  }
  if (!width || !height) {
    width = 360;
    height = 202;
  }
  // icon default size 34 23
  const iconX = parseInt(width / 2 - (34 * iconScale) / 2);
  const iconY = parseInt(height / 2 - (23 * iconScale) / 2);
  let template = `
  <svg viewBox='0 0 ${width} ${height}' version='1.1' xmlns='http://www.w3.org/2000/svg'>
  <rect fill='#F2F4F8' x='0' y='0' width='${width}' height='${height}'></rect>
  <path transform="translate(${iconX}, ${iconY}) scale(${iconScale})" d='M27.1157474,1.463796 C29.6131474,4.075218 31.1546534,7.64357 31.1554304,11.580831 C31.1559914,14.428337 30.3478644,17.080566 28.9574384,19.318872 L27.5113244,18.466264 C28.7599314,16.478995 29.4868894,14.117579 29.4863894,11.580498 C29.4856734,7.949402 27.9993024,4.673878 25.6174014,2.347059 L23.0785284,3.843297 L21.5070314,4.770567 C21.5064754,4.770283 21.5061964,4.769999 21.5061964,4.769715 L18.6363364,6.461003 C18.6368924,6.461003 18.6371714,6.461287 18.6377274,6.461571 L16.9699934,7.444489 L15.2999234,6.460054 L12.4299524,4.767053 C12.4296744,4.767337 12.4296744,4.767337 12.4293964,4.767337 L10.8564204,3.840291 L8.31723635,2.342473 C5.93569535,4.668909 4.45006035,7.943842 4.45077635,11.575505 C4.45127935,14.129059 5.18890735,16.504684 6.45359935,18.50069 L5.00670935,19.35329 C3.60065635,17.106189 2.78230035,14.439151 2.78173535,11.575173 C2.78095935,7.637628 4.32161435,4.069322 6.81854135,1.458896 L4.34390035,0 C1.64344135,3.067645 -0.000876649364,7.124431 3.50636305e-07,11.574618 C0.000867350636,15.971979 1.60922335,19.984255 4.25386435,23.039902 L4.51309235,22.887155 L4.52895335,22.914707 L9.47374635,20.000592 L9.45816335,19.972756 L10.7420634,19.21612 C8.59837635,17.392334 7.23311635,14.647084 7.23251135,11.57606 C7.23210135,9.499363 7.85872535,7.574453 8.92548435,5.98079 L10.3724324,6.833967 C9.44582335,8.174604 8.90120335,9.810405 8.90155235,11.576393 C8.90209835,14.35034 10.2469944,16.801917 12.3054944,18.294812 L15.1291834,16.63078 C13.1186734,15.86667 11.6837434,13.895339 11.6832864,11.576948 C11.6830404,10.32701 12.1025774,9.179685 12.8017254,8.266157 L16.6448604,10.53192 L16.9706394,10.723978 L18.1627524,10.021285 L21.1358034,8.269523 C21.8344774,9.183045 22.2536324,10.329686 22.2538784,11.579056 C22.2543354,13.896027 20.8221304,15.865934 18.8138694,16.630378 L21.6371014,18.294685 C23.6936214,16.802611 25.0361604,14.352138 25.0356134,11.579611 C25.0352654,9.814191 24.4905574,8.179024 23.5639754,6.838302 L25.0108654,5.985702 C26.0774194,7.579507 26.7042454,9.504098 26.7046544,11.579943 C26.7052594,14.649831 25.3421944,17.393685 23.2008964,19.2169 L25.7289524,20.707616 C25.7317334,20.704777 25.7342364,20.701937 25.7367394,20.699381 L27.2290354,21.578981 C27.2265324,21.58182 27.2240294,21.58466 27.2218044,21.5875 L29.6897684,23.042702 C32.3320924,19.988394 33.9380314,15.97761 33.9371644,11.581386 C33.9362874,7.131483 32.2909264,3.074609 29.5895344,0.005886 L27.1157474,1.463796 Z' fill='${iconColor}'></path>
  </svg>`;
  template = template.replace(/[\r\n]/g, '');
  return `data:image/svg+xml;charset=utf8,${encodeURIComponent(template)}`;
}
const clientWidth = document.body.clientWidth;

const extWebp = /\.webp$/;
const isCdn = /^https*:\/\/www\.cdnmore\.com/;
function replaceWebp(src) {
  // 如果支持webp直接返回
  if (isSupportWebp()) {
    return src;
  }
  // 只处理自己cdn下的文件
  if (!isCdn.test(src)) {
    return src;
  }
  let nSrc = src;
  const srcs = src.split('?');
  // 取到的了参数
  if (srcs.length && srcs[1]) {
    if (srcs[0].endsWith('.webp')) {
      // 取真正的ext
      let params = URL.getPara(srcs[1], true);
      // 只要有ext参数就行
      if (srcs[1].indexOf('ext=') > -1) {
        srcs[0] = srcs[0].replace(extWebp, params.ext ? `.${params.ext}` : '');
        // 删除ext
        delete params.ext;
        nSrc = URL.addPara(srcs[0], params);
        // 结尾只有？。则删除问号
        nSrc = nSrc.replace(/\?$/, '');
      }
    }
  }
  return nSrc;
}
export function debounce(func, delay) {
  // 防抖
  let timer = null;
  return function () {
    const context = this;
    const args = arguments;
    if (timer !== null) {
      clearTimeout(timer);
    }
    timer = setTimeout(() => {
      func.apply(context, args);
    }, delay);
  };
}
/**
 *
 * @param {Elemnt} element dom node
 * @param {string} html
 */
export function html(element, html) {
  if (!element || !element.nodeType || !html) {
    return;
  }
  const fragment = document.createElement('div');
  fragment.innerHTML = html;
  const scripts = Array.from(fragment.querySelectorAll('script')) || [];
  scripts.forEach(script => script.parentNode.removeChild(script));
  scripts.forEach(script => {
    const s = document.createElement('script');
    if (script.src) {
      s.src = script.src;
    } else if (script.innerHTML) {
      s.innerHTML = script.innerHTML;
    }
    element.appendChild(s);
  });
  const imgs = Array.from(fragment.querySelectorAll('img')) || [];
  imgs.forEach(img => {
    let src = img.src;
    let w = Number(img.getAttribute('data-image-width'));
    let h = Number(img.getAttribute('data-image-height'));
    if (w && h) {
      if (w > clientWidth) {
        img.src = generateLoadingDataURL(clientWidth, (clientWidth * h) / w);
      } else {
        img.src = generateLoadingDataURL(w, h);
      }
    } else {
      img.src = generateLoadingDataURL();
    }
    img.setAttribute('data-src', replaceWebp(src));
    img.className += ' lazyload';
  });
  element.appendChild(fragment);
}

// 只区分ios和android
export function getOsType() {
  const userAgent = navigator.userAgent.toLowerCase();
  const platform = (navigator.platform || '').toLowerCase();
  if (platform.indexOf('mac') >= 0) {
    return 'mac';
  } else if (userAgent.indexOf('iphone') >= 0 || userAgent.indexOf('ipad') >= 0 || userAgent.indexOf('ipod') >= 0) {
    return 'ios';
  } else if (userAgent.indexOf('android') >= 0 || userAgent.indexOf('adr ') >= 0) {
    return 'android';
  }
}

export function isEmptyObject(obj) {
  var name;
  for (name in obj) {
    return false;
  }
  return true;
}

// 将rem转换成px像素
export function remToPx(obj) {
  let bodyFontSize = window.getComputedStyle(document.body).fontSize;
  bodyFontSize = parseInt(bodyFontSize);
  return +obj * bodyFontSize;
}

// 分类记住当前的scrollTop
export function tagMemoryScrollTop(iniData) {
  return (function (iniData) {
    const data = iniData || {};
    return {
      beforeChange(preId) {
        // 切换时记住上次的tab
        data[preId] = Math.max(document.body.scrollTop, document.documentElement.scrollTop);
      },
      change(id) {
        if (data[id] >= 0) {
          document.body.scrollTop = data[id];
          document.documentElement.scrollTop = data[id];
        }
      },
    };
  })(iniData);
}

export const domainReg = /^(https*:\/\/|\/\/)\w+\.more\.buzz*/;
export const isabsoluteUrl = /^(https*:\/\/|\/\/)/;

// 如果有isForce会强制取本地的国家去跳转，否则回去取url地址上的跳转
export function jumpWidthCountry(url, isForce = false) {
  const config = window.config || {};
  if (!url || typeof url !== 'string') {
    return url;
  }
  // 国家信息还没有初始化
  if (!config.lang || !config.country) {
    return url;
  }
  // 如果说本身url上就带国家，则返回带的国家
  const par = URL.getPara(url, true);
  if (par.country && par.lang) {
    return url;
  }

  let country = config.country;
  let lang = config.lang;
  // 不是强制跳转，则根据当前访问url上参数决定去哪个国家
  if (!isForce) {
    const params = URL.getPara(window.location.href, true);
    if (!params.country || !params.lang) {
      return url;
    }
    lang = params.lang;
    country = params.country;
  }
  // 绝对地址必须是主域名
  if ((url.indexOf('/') > -1 || url.startsWith('?')) && (!isabsoluteUrl.test(url) || domainReg.test(url))) {
    url = URL.addPara(
      url,
      {
        country,
        lang,
      },
      true
    );
  }
  return url;
}
window.jumpWidthCountry = jumpWidthCountry;

// 是否支持webp
let isSupWebp;
export function isSupportWebp() {
  if (isSupWebp !== undefined) {
    return isSupWebp;
  }
  try {
    isSupWebp =
      document
        .createElement('canvas')
        .toDataURL('image/webp')
        .indexOf('data:image/webp') === 0;
    return isSupWebp;
  } catch (err) {
    isSupWebp = false;
    return false;
  }
}

// format audio 时长, time单位为秒
export function formatDuration(time) {
  time = Math.floor(time);
  const min = Math.floor(time / 60);
  const sec = Math.floor(time % 60);
  return `${min < 10 ? '0' + min : min}:${sec < 10 ? '0' + sec : sec}`;
}

// format audio 大小, size单位为KB
export function formatAudioSize(size) {
  if (!size) {
    return '';
  }
  let m = Math.round((size / 1024) * 100) / 100;
  if (m <= 0) {
    return '0MB';
  }
  let s = m + '';
  if (s[s.length - 1] === '0') {
    s = s.substr(0, s.length - 1);
  }
  return s + 'MB';
}

export function formatDecimal(num) {
  num = num + '';
  return num.replace(/\d{1,3}(?=(\d{3})+(\.|$))/g, '$&,');
}

export function getQuery() {
  const params = URL.getPara(true) || {};
  return params;
}

export function getUrlParams(key) {
  const params = new URLSearchParams(window.location.search);
  return params.get(key);
}

export function isMyBoboup() {
  return window.location.hostname.includes('pokabb.com');
}

const IOS_UA = {
  userid: 'uid',
  platform: 'platform_type',
  manufacturer: 'device_manufacturer',
  model: 'device_model',
  versionInt: 'build_version',
  apiLevel: 'api_version',
  gender: 'user_gender',
  appPlatform: 'platform_of_app',
  lang: 'user_language',
  country: 'user_country',
  // 兼容前两个 ios 版本
  area: ['user_area', 'area'],
  version: ['app_version', 'version'],
  deviceId: ['app_deviceId', 'deviceId'],
  Authorization: ['authKey', 'Authorization'],
  statusBarHeight: 'statusBarHeight',
};

const BOBOUP_UA = {
  userid: 'userIdentity',
  platform: 'osType',
  manufacturer: 'dManufacturer',
  model: 'dModel',
  versionInt: 'appBuildVer',
  apiLevel: 'apiProtocolVer',
  gender: 'sexType',
  appPlatform: 'platformNumValue',
  lang: 'user_language',
  country: 'user_country',
  // 兼容前两个 ios 版本
  area: 'userZone',
  version: 'appVer',
  deviceId: 'devID',
  Authorization: 'authToken',
  statusBarHeight: 'topSpacing',
}

export function getValueFromUA(key) {
  // const userAgent = 'Mozilla/5.0 (Linux; Android 10; Infinix X680B Build/QP1A.190711.020; wv) AppleWebKit/537.36 (KHTML, like Gecko) Version/4.0 Chrome/95.0.4638.74 Mobile Safari/537.36 company/soulu client/soulu country/HK lang/en version/1.0.1 versionInt/7 android/10 manufacturer/HUAWEI model/EML-AL00 channel/null deviceId/7ac76048-5547-42cb-b9c1-b55bf50e8e4b userid/1465223513640239105 sessionId/d1d9c079c763c265913373934997aab5';
  const userAgent = navigator.userAgent || '';
  const isBoboup = isMyBoboup();
  let test;
  const isIos = getOsType() !== 'android';
  if (isIos) {
    if (Object.keys(IOS_UA).includes(key) && !isBoboup) {
      if (userAgent.includes('app_version')) {
        key = Array.isArray(IOS_UA[key]) ? IOS_UA[key][0] : IOS_UA[key];
      } else {
        key = Array.isArray(IOS_UA) ? IOS_UA[key][1] : IOS_UA[key];
      }
      test = new RegExp(`(?:app_name\/lumos)(?:.*)\\s+${key}\/(.+?)(?=\\s+[a-zA-Z0-9_]+/|$)`);
    }

    if (isBoboup) {
      key = BOBOUP_UA[key];
      test = new RegExp(`(?:appTitle\/hope)(?:.*)\\s+${key}\/(.+?)(?=\\s+[a-zA-Z0-9_]+/|$)`);
    }
  } else {
    test = new RegExp(`(?:company\/soulu\\sclient\/soulu)(?:.*)\\s+${key}\/(.+?)(?=\\s+[a-zA-Z0-9_]+/|$)`);
  }
  const p = userAgent.match(test);
  if (p && p[1]) {
    let value = p[1].trim();
    // 如果在 modal 中使用，将 + 号替换为空格
    if (key === 'model') {
      value = value.replace(/[+\uff0b]/g, ' ');
    }
    return value;
  }
  return '';
}

export function throttle(func, wait) {
  let timeout;
  return function () {
    let context = this;
    let args = arguments;
    if (!timeout) {
      timeout = setTimeout(() => {
        timeout = null;
        func.apply(context, args);
      }, wait);
    }
  };
}

export const withRouter = (Component) => {
  const ComponentWithRouterProp = (props) => {
    let location = useLocation();
    let navigate = useNavigate();
    let params = useParams();
    return (
      <Component
        {...props}
        router={{ location, navigate, params }}
      />
    );
  }

  return ComponentWithRouterProp;
}

export function upFixed(num, fix) {
  // num为原数字，fix是保留的小数位数
  let result = '0';
  if (Number(num) && fix > 0) {
    // 简单的做个判断
    fix = +fix || 2;
    num = num + '';
    if (/e/.test(num)) {
      // 如果是包含e字符的数字直接返回
      result = num;
    } else if (!/\./.test(num)) {
      // 如果没有小数点
      result = num + `.${Array(fix + 1).join('0')}`;
    } else {
      // 如果有小数点
      num = num + `${Array(fix + 1).join('0')}`;
      let reg = new RegExp(`-?\\d*\\.\\d{0,${fix}}`);
      let floorStr = reg.exec(num)[0];
      if (+floorStr >= +num) {
        result = floorStr;
      } else {
        let floorNumber = +floorStr + +`0.${Array(fix).join('0')}1`;
        let point = /\./.test(floorNumber + '') ? '' : '.';
        let floorStr2 = floorNumber + point + `${Array(fix + 1).join('0')}`;
        result = reg.exec(floorStr2)[0];
      }
    }
  }
  if (Number(num) && fix === 0) {
    return Math.ceil(num);
  }
  return result;
}
export function downFixed(num, fix) {
  // num为原数字，fix是保留的小数位数
  let result = '0';
  if (Number(num) && fix > 0) {
    // 简单的做个判断
    fix = +fix || 2;
    num = num + '';
    if (/e/.test(num)) {
      // 如果是包含e字符的数字直接返回
      result = num;
    } else if (!/\./.test(num)) {
      // 如果没有小数点
      result = num + `.${Array(fix + 1).join('0')}`;
    } else {
      // 如果有小数点
      num = num + `${Array(fix + 1).join('0')}`;
      let reg = new RegExp(`-?\\d*.\\d{0,${fix}}`);
      result = reg.exec(num)[0];
    }
  }
  if (Number(num) && fix === 0) {
    return Math.floor(num);
  }
  return result;
}

export const formatThousandNum = (v, fix = 1, type, forceFix) => {
  const num = Number(v);
  if (isNaN(num)) {
    return '';
  }
  if (num < 10000) {
    if (forceFix) {
      if (type === 'up') {
        return `${upFixed(num, fix)}`;
      } else if (type === 'down') {
        return `${downFixed(num, fix)}`;
      } else {
        return `${num.toFixed(fix)}`;
      }
    }
    return num;
  }
  if (num >= 10000) {
    const target = Number(num / 1000);
    if (type === 'up') {
      return `${upFixed(target, fix)}K`;
    } else if (type === 'down') {
      return `${downFixed(target, fix)}K`;
    } else {
      return `${target.toFixed(fix)}K`;
    }
  }
};

// 小于版本号判断
export function compareVersion(last) {
  // const last = ['2', '0', '1'];
  const cur = getValueFromUA('version');
  const arr = cur ? cur.split('.') : false;
  if (!arr || !arr.length) return true;
  if (arr[0] < last[0]) {
    return true;
  } else {
    if (arr[0] === last[0]) {
      if (arr[1] < last[1]) {
        return true;
      } else {
        if (arr[1] === last[1]) {
          if (arr[2] < last[2]) {
            return true;
          }
        }
      }
    }
  }
  return false;
}

export const getScrollY = () => {
  return window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
}

export const formatNum = (v, fix = 1, type, forceFix) => {
  const num = Number(v);
  if (isNaN(num)) {
    return '';
  }
  if (num < 1000) {
    if (forceFix) {
      if (type === 'up') {
        return `${upFixed(num, fix)}`;
      } else if (type === 'down') {
        return `${downFixed(num, fix)}`;
      } else {
        return `${num.toFixed(fix)}`;
      }
    }
    return num;
  }
  if (num >= 1000 && num < 1000000) {
    const target = Number(num / 1000);
    if (type === 'up') {
      return `${upFixed(target, fix)}K`;
    } else if (type === 'down') {
      return `${downFixed(target, fix)}K`;
    } else {
      return `${target.toFixed(fix)}K`;
    }
  }
  const target = Number(num / 1000000);
  if (type === 'up') {
    return `${upFixed(target, fix)}M`;
  } else if (type === 'down') {
    return `${downFixed(target, fix)}M`;
  } else {
    return `${target.toFixed(fix)}M`;
  }
};